import styled from "styled-components";
import { theme } from '../../theme'

export const MediaGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(17.02rem, 1fr));
    grid-column-gap: .875rem;
    grid-row-gap: 3.307rem;
    margin-bottom: 5.5rem;
`
